// Milestone-aware overall case progress (0-100).
// A completed stage counts fully. A stage that is still in progress earns
// partial credit based on the fraction of its milestones (subcategories) that
// have been ticked, so the percentage rises gradually during long stages.
export function getCaseProgress(stages) {
  if (!stages || !stages.length) return 0;
  let total = 0;
  for (const s of stages) {
    if (s.status === "completed") {
      total += 1;
    } else {
      const subs = s.subcategories || [];
      if (subs.length) {
        const done = subs.filter((x) => x.completed).length;
        total += done / subs.length;
      }
    }
  }
  return Math.round((total / stages.length) * 100);
}
